(() => {
  const initialize = () => document.querySelectorAll('[data-support-center]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const input = root.querySelector('[data-support-search]');
    const topics = [...root.querySelectorAll('[data-support-topic]')];
    const status = root.querySelector('[data-support-status]');
    const empty = root.querySelector('[data-support-empty]');
    input.addEventListener('input', () => {
      const words = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      topics.forEach(topic => {
        topic.hidden = !words.every(word => topic.dataset.search.toLowerCase().includes(word));
        if (!topic.hidden) count++;
      });
      status.hidden = !words.length;
      status.textContent = (window.sonicStrings?.['support_matches_' + new Intl.PluralRules(document.documentElement.lang || 'en').select(count)] || `${count} matching support ${count === 1 ? 'topic' : 'topics'}`).replaceAll('[count]', () => count);
      empty.hidden = count !== 0;
    });
    const buttons = [...root.querySelectorAll('[data-support-view]')];
    buttons.forEach(button => button.addEventListener('click', () => {
      root.querySelector('[data-support-topics]').dataset.layout = button.dataset.supportView;
      buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    }));
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
